import * as React from "react";

export default function ServicesBigIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
    >
      <g
        id="Group_5669"
        data-name="Group 5669"
        transform="translate(-1102 -95)"
      >
        <circle
          id="Ellipse_1754"
          data-name="Ellipse 1754"
          cx="30.5"
          cy="30.5"
          r="30.5"
          transform="translate(1102 95)"
          fill="#f2eeff"
        />
        <g
          id="Iconly_Light-Outline_Setting"
          data-name="Iconly/Light-Outline/Setting"
          transform="translate(1120.095 112.804)"
        >
          <g id="Setting" transform="translate(0)">
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M11.4,26.2a3.371,3.371,0,0,1-3.368-3.367,1.362,1.362,0,0,0-.191-.672,1.478,1.478,0,0,0-.89-.693,1.416,1.416,0,0,0-.368-.048,1.477,1.477,0,0,0-.735.2,3.451,3.451,0,0,1-1.674.436,3.352,3.352,0,0,1-.909-.125,3.394,3.394,0,0,1-2.023-1.605l-.79-1.362a3.361,3.361,0,0,1,1.227-4.583,1.471,1.471,0,0,0,0-2.548A3.375,3.375,0,0,1,.447,7.232L1.3,5.824A3.364,3.364,0,0,1,5.883,4.6a1.39,1.39,0,0,0,.7.2A1.471,1.471,0,0,0,8.04,3.353,3.352,3.352,0,0,1,11.4,0h1.584a3.362,3.362,0,0,1,3.367,3.462,1.341,1.341,0,0,0,.191.645,1.463,1.463,0,0,0,.894.68,1.565,1.565,0,0,0,.369.046,1.443,1.443,0,0,0,.738-.2,3.378,3.378,0,0,1,4.6,1.236l.787,1.364a1.039,1.039,0,0,1,.053.108A3.38,3.38,0,0,1,22.7,11.822a1.433,1.433,0,0,0-.536.532,1.492,1.492,0,0,0-.152,1.116,1.445,1.445,0,0,0,.683.889,3.356,3.356,0,0,1,1.227,4.6l-.84,1.4A3.368,3.368,0,0,1,18.5,21.568a1.5,1.5,0,0,0-.705-.2h-.007a1.474,1.474,0,0,0-1.014.428,1.442,1.442,0,0,0-.427,1.038A3.379,3.379,0,0,1,12.979,26.2ZM7.438,19.632A3.384,3.384,0,0,1,9.475,21.2a3.249,3.249,0,0,1,.449,1.619A1.478,1.478,0,0,0,11.4,24.3h1.584a1.473,1.473,0,0,0,1.471-1.463,3.358,3.358,0,0,1,3.287-3.362h.085a3.466,3.466,0,0,1,1.62.447,1.48,1.48,0,0,0,2.01-.532l.84-1.4A1.461,1.461,0,0,0,21.754,16a3.345,3.345,0,0,1-1.57-2.046,3.381,3.381,0,0,1,.342-2.553,3.335,3.335,0,0,1,1.228-1.224,1.472,1.472,0,0,0,.528-2,.613.613,0,0,1-.044-.086L21.5,6.814a1.474,1.474,0,0,0-2.006-.543,3.306,3.306,0,0,1-1.682.462,3.383,3.383,0,0,1-2.9-1.662,3.237,3.237,0,0,1-.454-1.626,1.512,1.512,0,0,0-.415-1.1A1.475,1.475,0,0,0,12.979,1.9H11.4a1.46,1.46,0,0,0-1.035.428,1.443,1.443,0,0,0-.423,1.037A3.391,3.391,0,0,1,6.57,6.7,3.276,3.276,0,0,1,4.927,6.24a1.434,1.434,0,0,0-.711-.187,1.479,1.479,0,0,0-1.281.738L2.079,8.2a1.462,1.462,0,0,0,.546,1.984,3.366,3.366,0,0,1,0,5.83A1.46,1.46,0,0,0,2.09,18l.8,1.376a1.48,1.48,0,0,0,2.015.587,3.3,3.3,0,0,1,1.673-.447A3.364,3.364,0,0,1,7.438,19.632ZM7.913,13.1a4.28,4.28,0,1,1,4.28,4.279A4.285,4.285,0,0,1,7.913,13.1Zm1.9,0a2.384,2.384,0,1,0,2.384-2.385A2.386,2.386,0,0,0,9.809,13.1Z"
              fill="#111"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
